import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const MobileAdhesion = /*#__PURE__*/ React.memo(()=>{
    useAdUnit(AdProviders.Nitro, ADUNIT_MAP['MobileAdhesion'], {
        debug: process.env.NODE_ENV !== 'production',
        refreshLimit: 10,
        refreshTime: 90,
        format: 'anchor',
        anchor: 'bottom',
        anchorPersistClose: false,
        report: {
            enabled: true,
            icon: true,
            wording: 'Report Ad',
            position: 'top-right'
        },
        mediaQuery: '(min-width: 768px) and (max-width: 1024px), (min-width: 320px) and (max-width: 767px)'
    });
    return null; // anchors DONT need a div
}, ()=>true // never rerender
);
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
